export function AbstractInstantiationError (obj) {
  return new TypeError('Do not instantiate `' + obj.constructor.name + '` directly, use a subclass instead')
}



// WEBPACK FOOTER //
// ./util/index.js